export default "__VITE_ASSET__M_9h9gYl__"